import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  MapPin,
  Users,
  ShoppingBag,
  Home,
  MessageCircle,
  Bell,
  BriefcaseBusiness,
  ShieldCheck,
} from "lucide-react";
import "./HowCivilinkWorks.css";

export default function HowCivilinkWorks() {
  const navigate = useNavigate();

  const features = [
    {
      icon: MapPin,
      title: "Set Your Location",
      description:
        "Set your location to discover relevant professionals, properties, products and services around you.",
    },
    {
      icon: Users,
      title: "Find Professionals",
      description:
        "Discover engineers, architects, workers and other construction professionals on Civilink.",
    },
    {
      icon: ShoppingBag,
      title: "Construction Marketplace",
      description:
        "Explore construction materials, products, equipment and services from vendors.",
    },
    {
      icon: Home,
      title: "Buy, Sell & Rent",
      description:
        "Discover properties available for buying, selling or renting through Civilink.",
    },
    {
      icon: MessageCircle,
      title: "Connect & Chat",
      description:
        "Connect and communicate with professionals, vendors, property owners and other users.",
    },
    {
      icon: Bell,
      title: "Stay Updated",
      description:
        "Receive notifications about messages, listings, posts and other Civilink activities.",
    },
  ];

  return (
    <div className="how-civilink-page">

      <header className="how-civilink-header">
        <button
          className="how-civilink-back"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={20} />
        </button>

        <div>
          <h1>How Civilink Works</h1>
          <p>Explore the Civilink ecosystem</p>
        </div>
      </header>

      <main>

        {/* HERO */}
        <section className="how-civilink-hero">

          <div className="how-civilink-hero-icon">
            <BriefcaseBusiness size={32} />
          </div>

          <div>
            <span>WELCOME TO CIVILINK</span>

            <h2>
              One platform for the
              <br />
              construction ecosystem.
            </h2>

            <p>
              Civilink brings construction professionals,
              vendors, property owners, buyers, sellers and
              construction products together in one platform.
            </p>
          </div>

        </section>

        {/* FEATURES */}
        <section className="how-civilink-section">

          <div className="how-civilink-section-title">
            <span>EXPLORE</span>
            <h2>What you can do with Civilink</h2>
            <p>
              Discover the different services and features
              available on the platform.
            </p>
          </div>

          <div className="how-civilink-grid">

            {features.map((feature) => {
              const Icon = feature.icon;

              return (
                <div
                  className="how-civilink-card"
                  key={feature.title}
                >
                  <div className="how-civilink-card-icon">
                    <Icon size={22} />
                  </div>

                  <div>
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </div>
                </div>
              );
            })}

          </div>

        </section>

        {/* STEPS */}
        <section className="how-civilink-section">

          <div className="how-civilink-section-title">
            <span>GET STARTED</span>
            <h2>How to get started</h2>
          </div>

          <div className="how-civilink-steps">

            <div className="how-civilink-step">
              <strong>01</strong>
              <h3>Create your account</h3>
              <p>
                Sign in to Civilink and complete your profile.
              </p>
            </div>

            <div className="how-civilink-step">
              <strong>02</strong>
              <h3>Set your location</h3>
              <p>
                Select your location to receive relevant
                location-based services and content.
              </p>
            </div>

            <div className="how-civilink-step">
              <strong>03</strong>
              <h3>Explore Civilink</h3>
              <p>
                Browse professionals, marketplace products,
                properties, posts and other services.
              </p>
            </div>

            <div className="how-civilink-step">
              <strong>04</strong>
              <h3>Connect & grow</h3>
              <p>
                Connect with people and businesses across
                the construction ecosystem.
              </p>
            </div>

          </div>

        </section>

        {/* TRUST */}
        <section className="how-civilink-trust">

          <ShieldCheck size={27} />

          <div>
            <h3>Built for the construction ecosystem</h3>

            <p>
              Civilink is designed to connect people,
              professionals, businesses, products and
              properties in one place.
            </p>
          </div>

        </section>

      </main>
    </div>
  );
}